/* @ngInject */
function NgsTicketsInterceptor($window, LocalData) {
  /**
   * @param {string} url
   *
   * @returns {boolean}
  */
  const isValidUrl = (url) => url.includes(process.env.NGS_TICKETS_API);

  /**
   * @param {Object} request
  */
  const addAuthToken = (request) => {
    const basicAuthData = `${process.env.NGS_TICKETS_API_BASIC_AUTH_USERNAME}:${process.env.NGS_TICKETS_API_BASIC_AUTH_PASSWORD}`;
    const basicAuth = `Basic ${$window.btoa(basicAuthData)}`;

    request.headers.Authorization = basicAuth;
  };

  /**
   * @param {Object} request
   */
  const addTenantInfo = (request) => {
    request.headers['X-Nsft-Ngs-Company'] = LocalData.betshop.companyUuid;
  };

  return {
    /**
     * @param {Object} requestConfig
     *
     * @returns {Object}
     */
    request(requestConfig) {
      if (isValidUrl(requestConfig.url)) {
        addAuthToken(requestConfig);
        addTenantInfo(requestConfig);
      }

      return requestConfig;
    }
  };
}

export default NgsTicketsInterceptor;
